import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import debounce from 'es6-promise-debounce';
import Async from 'react-select/lib/Async';
import 'react-select/dist/react-select.css';
import 'react-virtualized-select/styles.css';
import { rem } from 'polished';
import { __ } from '../../Utils';

const SelectWrapper = styled.div`
  width: ${props => (props.minWidth ? props.minWidth : 'auto')};
  z-index: 4;
  .Select-control {
    border: ${({ theme, error }) =>
      error
        ? `solid ${rem(1)} ${theme.color.danger}`
        : `solid ${rem(1)} ${theme.separatorColor}`};
    background-color: ${({ theme, error }) =>
      error && `${theme.color.danger}18`};
  }
`;

class SearchableSelect extends React.Component {
  render() {
    const {
      multiple,
      name,
      placeholder,
      error,
      handleOnChange,
      value,
      disabled,
      loadOptions,
      noLoadOptions,
      id,
      styles,
      minWidth,
      filterOptions,
      autoload,
      keyProps,
    } = this.props;
    return (
      <SelectWrapper
        style={styles}
        error={error}
        data-tip
        minWidth={minWidth}
        data-for={`${id}-tooltip`}
      >
        <Async
          multiple={multiple}
          name={name}
          value={value}
          cacheOptions
          filterOptions={filterOptions}
          autoload={autoload}
          loadOptions={
            loadOptions
              ? debounce(query => loadOptions(query), 600)
              : noLoadOptions
          }
          disabled={disabled}
          placeholder={placeholder}
          loadingMessage={() => ({
            inputValue: __('Načítavanie.'),
          })}
          onChange={val => handleOnChange(val)}
          key={keyProps}
        />
      </SelectWrapper>
    );
  }
}

SearchableSelect.propTypes = {
  id: PropTypes.string,
  minWidth: PropTypes.string,
  tooltip: PropTypes.bool,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
    PropTypes.string,
  ]).isRequired,
  loadOptions: PropTypes.func.isRequired,
  noLoadOptions: PropTypes.func,
  styles: PropTypes.shape({}),
  filterOptions: PropTypes.bool,
  autoload: PropTypes.bool,
};

SearchableSelect.defaultProps = {
  styles: {},
  id: '',
  tooltip: false,
  multiple: false,
  placeholder: '',
  minWidth: null,
  error: false,
  disabled: false,
  autoload: false,
  filterOptions: false,
  noLoadOptions: () => {
    return new Promise(resolve => {
      resolve([]);
    });
  },
};

export default SearchableSelect;



// WEBPACK FOOTER //
// ./src/Components/SearchableSelect/index.jsx